import React from 'react';

import { useSelector } from 'react-redux';

import { RibbonButton } from 'common/components';
import { UploadOutlined } from '@ant-design/icons';
import { makeSelectAplDetail } from 'pages/product-apl-detail/controllers/selectors';

import UploadTemplateAPLModal from '../../sections/product-apl/components/UploadTemplateAPLModal';
import { useGlobalModal } from 'hooks';
import { useCheckDisabledMasterAplBtn } from '../../sections/product-apl/hooks';

import Messages from 'i18n/messages/home';
import { MASTER_APL_NAME } from '../../sections/product-apl/constants';

const UploadProductApl = () => {
  const { openModal, MODAL_NAMES, checkModalVisible, closeAllModal } =
    useGlobalModal();

  const aplDetail = useSelector(makeSelectAplDetail());
  const visibleModal = checkModalVisible(MODAL_NAMES.UPDATE_MASTER_APL);

  const isDisabledMasterAplBtn = useCheckDisabledMasterAplBtn(aplDetail);

  const checkDisabledUploadAplBtn = () => {
    if (aplDetail?.aplName === MASTER_APL_NAME) return isDisabledMasterAplBtn;
    return !aplDetail?.isOwner;
  };

  const isDisabledBtn = checkDisabledUploadAplBtn();

  return (
    <>
      <RibbonButton
        size='small'
        icon={<UploadOutlined style={{ height: 26 }} />}
        className='button-item-dropdown'
        label={Messages.uploadTemplate}
        onClick={() => openModal(MODAL_NAMES.UPDATE_MASTER_APL)}
        disabled={isDisabledBtn}
      />
      <UploadTemplateAPLModal
        visibleModal={visibleModal}
        aplId={aplDetail?.aplId}
        turnOffModal={() => closeAllModal()}
        aplDetail={aplDetail}
      />
    </>
  );
};

export default UploadProductApl;
